import { NgModule } from '@angular/core';

// Modules Material utilises

// Autres modules externes utilises 

// Modules communs utilises

// Composants metiers

// Services metier
import { ModeleOuvrageService } from './services/modele-ouvrage.service';

@NgModule({
	imports: [
	],
	providers: [
		ModeleOuvrageService,
	],
	declarations: [
	],
	exports: [
	]
})
export class ModeleOuvrageModule {
	constructor() { }
}